import { makeAutoObservable, observable } from 'mobx';

// Raw JSON from backend
export type RoundInfoJson = {
  options: Record<string, any>;
  name?: string;
  description?: string;
};

// Observable model type
export type RoundInfo = RoundInfoJson & {
  toJS(): RoundInfoJson;
};

// Factory function
export function createRoundInfo(json?: Partial<RoundInfoJson>): RoundInfo {
  return makeAutoObservable({
    options: observable.map(json?.options || {}),
    name: json?.name,
    description: json?.description,

    toJS(): RoundInfoJson {
      return {
        options: Object.fromEntries(this.options),
        name: this.name,
        description: this.description,
      };
    },
  });
}
